
import { useState, useMemo } from "react";
import {
  useSortable,
} from '@dnd-kit/sortable';
import { CaretRightOutlined, MenuOutlined } from '@ant-design/icons'
import { CSS } from '@dnd-kit/utilities';
import { Tooltip } from "antd";
import talkIcon from "src/assets/svgs/icon-talk.svg"
import { 
  MultipleListsPopover,
} from 'src/DigitalProtocolModule/components'
import { fetchHistory } from "src/actions/historyTrial";
import { ActivityFootnoteTooltip } from "../ActivityFootnoteTooltip";
import { useSelector } from "react-redux";
import { FOOTNOTE_GROUP } from "src/DigitalProtocolModule/constants";
import { useFootnoteHooks } from "src/DigitalProtocolModule/hooks";
import styles from "./index.module.scss";

const items: Digital_Protocol_SoA_Table_Data.PopoverItemsList[] = [
{ name: "Add Visit", icon: "PlusCircleOutlined", color: "black" },
{ name: "Delete Visit", icon: "MinusCircleOutlined", color: "black" },
{ name: "Duplicate Visit", icon: "CopyOutlined", color: "black" },
{ name: "Reset Visit", icon: "ClearOutlined", color: "black" },
{ name: "Move Visit", icon: "MenuOutlined", color: "black" },
{ name: "Add Footnote", icon: "FormOutlined", color: "black" },
];

interface DraggableVisitProps {
  item: number;
  idx: number;
  onAction: (name: string, idx: number) => void;
  key:string
  whetherVisitDraggable: number,
  handleEditInFootnoteTooltip: (footnote_type_id: number, otherParams: any) => void
  handleDeleteFootnote: (footnote_id: any[]) => void
  isReadOnly?: boolean;
}

export function DraggableVisit({
  idx,
  key,
  item,
  whetherVisitDraggable,
  onAction,
  handleEditInFootnoteTooltip,
  handleDeleteFootnote,
  isReadOnly = false,
}: DraggableVisitProps) {

  const footnoteConfigState = useSelector(fetchHistory).data.dpFootnoteConfig;

  const { getFootnoteStateMergedWithSoftSave } = useFootnoteHooks()

  const [footnoteMergedDataState] = useState(getFootnoteStateMergedWithSoftSave())

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    // isDragging,
  } = useSortable({id: item, disabled: whetherVisitDraggable !== item});

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: `${whetherVisitDraggable !== item? 'default' : 'move'}`,
    touchAction: 'none',
  };

  const visitFootnoteList = useMemo(() => {
    return footnoteMergedDataState?.filter(
      (footnoteItem: DPFootnote.FootnoteData) =>
        footnoteItem?.footnote_group === FOOTNOTE_GROUP.VISIT && 
        footnoteItem.visit === item
      ).map((item: DPFootnote.FootnoteData) => {
        const footnoteType = footnoteConfigState.footnoteTypeList.find(typeItem => typeItem.footnote_type_id === item.footnote_type_id)
        return {
          ...item,
          footnote_type: footnoteType?.footnote_type
        }
    });
  }, [footnoteConfigState, footnoteMergedDataState]);

  return (
    <>

    <div
      className="td num-cell"  
      id={item.toString()}
      ref={setNodeRef}  
      style={{...style,
      }} 
      key={item}
      {...attributes} 
      {...listeners}
    >
      <MenuOutlined style={{fontSize: '8px',marginTop: '0px', marginLeft: '0px', color: `${whetherVisitDraggable !== item? 'transparent' : 'black'}`,}}/>
        V{item}

        {visitFootnoteList?.length > 0 && (
          <>
            <Tooltip title={
              <ActivityFootnoteTooltip
                footnoteList={visitFootnoteList}
                visitNumber={item}
                isReadOnly={isReadOnly}
                onEdit={handleEditInFootnoteTooltip}
                onDel={handleDeleteFootnote}/>
              }
              overlayInnerStyle={{whiteSpace: "pre-wrap", borderRadius: 8, backdropFilter: "blur(3px)"}}
              overlayClassName="footnote-tooltip"
              placement="topRight"
              arrowPointAtCenter={true}
              zIndex={999}
              >              
            <img src={talkIcon} className={styles.talkIcon} alt="" />
            </Tooltip>
            </>
          )}
          {!isReadOnly && (
            <MultipleListsPopover
              items={items}
              onAction={onAction}
              idx={idx}
            >
              <CaretRightOutlined
                className={styles.triangleIcon}
              />
            </MultipleListsPopover>
          )}
    </div>
    </>
     
  )
}